import { ChevronRight } from "lucide-react";
import { INVESTMENT_TYPES, money } from "@/lib/finance";
import { CurrencyBadge, StatusBadge } from "@/components/finance/StatusBadge";

const Shell = ({ onClick, testid, children }) => (
  <button onClick={onClick} data-testid={testid} className="w-full text-left c-card p-4 flex items-center gap-3 active:scale-[0.99] transition-transform">
    <div className="flex-1 min-w-0 space-y-2">{children}</div>
    <ChevronRight className="w-5 h-5 c-muted shrink-0" />
  </button>
);

export const InvestmentCard = ({ item, onClick }) => {
  const { committed_amount: total, currency: c, stats } = item;
  const pct = total ? Math.min(100, (stats.contributed / total) * 100) : 0;
  return (
    <Shell onClick={onClick} testid="investment-card-item">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-semibold truncate" data-testid="investment-card-name">{item.name}</p>
          <p className="text-xs c-text-2 truncate">{item.associated_contact_name || "Socio sin definir"} · {INVESTMENT_TYPES[item.type] || "Tipo sin definir"}{item.agreed_yield_pct != null ? ` · ${item.agreed_yield_pct}%` : ""}</p>
        </div>
        <div className="flex flex-col items-end gap-1"><StatusBadge status={item.status} /><CurrencyBadge currency={c} /></div>
      </div>
      <div className="flex justify-between gap-2 text-xs font-mono tabular-nums">
        <span className="c-text-2" data-testid="investment-card-contributed">Aportado {money(stats.contributed)}</span>
        <span data-testid="investment-card-committed">de {money(total)}</span>
      </div>
      <div className="h-1.5 rounded-full bg-[var(--c-elev)] overflow-hidden"><div className="h-full bg-[#bc9538]" style={{ width: `${pct}%` }} /></div>
    </Shell>
  );
};

export const LoanCard = ({ item, onClick }) => (
  <Shell onClick={onClick} testid="loan-card-item">
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0">
        <p className="font-semibold truncate" data-testid="loan-card-name">{item.borrower_name}</p>
        <p className="text-xs c-text-2">{item.interest_rate_pct != null ? `${item.interest_rate_pct}% ${item.interest_periodicity || ""}` : "Interés sin definir"}</p>
      </div>
      <div className="flex flex-col items-end gap-1"><StatusBadge status={item.status} /><CurrencyBadge currency={item.currency} /></div>
    </div>
    <div className="flex justify-between items-baseline">
      <span className="text-xs c-text-2">Saldo pendiente</span>
      <span data-testid="loan-card-outstanding" className="font-mono font-bold tabular-nums">{money(item.stats.outstanding)}</span>
    </div>
  </Shell>
);
